<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">گزارش موجودی محصولات ها</h5>
                <div style="flex: 1"></div>
                <button class="btn btn-info" onclick="window.print()">پرینت</button>
            </div>
            <div class="row px-4 not-in-print">
                <div class="row col-12">
                    <div class="col-5">
                        <b-form-group label="دسته بندی">
                            <treeselect
                                :options="realOptions"
                                v-model="category_id"
                                :searchable="true"
                                :show-count="true"
                                noChildrenText="فرزندی وجود ندارد"
                                noOptionsText="موردی وجود ندارد"
                                noResultsText="موردی یافت نشد"
                                :default-expand-level="1"
                                label="title"
                            >
                                <label
                                slot="option-label"
                                slot-scope="{
                                    node,
                                    shouldShowCount,
                                    count,
                                    labelClassName,
                                    countClassName,
                                }"
                                :class="labelClassName"
                                >
                                {{ node.label }}
                                </label>
                            </treeselect>
                        </b-form-group>
                    </div>
                </div>
                <div class="row col-12 mb-2">
                    <div class="col-5 mb-1">
                        <label for="">انتخاب انبار</label>
                        <select name="" id="" class="form-control" v-model="selectedStore">
                            <option v-for="store in stores" :key="store.id" :value="store.id">{{ store.label }}</option>  
                        </select>
                    </div>
                </div>
                <div class="row col-12 mt-2">
                    <div class="col-4">
                        <b-button
                        class=""
                        variant="primary"
                        @click="doFilter"
                        :disabled="disabled"
                        >فیلتر</b-button>
                    </div>
                </div>
            </div>
            <div id="print" class="p-4">
                <div class="div" v-if="reports" v-for="product in reports">
                    <div class="container full-height d-flex justify-content-center align-items-center">  
                        <div class="row col-8 justify-content-between"> 
                            <div>  
                                <h6>  
                                    <span class="font-weight-bold">محصول: </span>  
                                    <span>{{ product.title }}</span>  
                                </h6>  
                            </div>  
                            <div>  
                                <h6 class="font-weight-bold">بررسی کننده:</h6>  
                            </div>  
                        </div>  
                    </div>  

                    <div class="container">  
                        <div class="row">  
                            <div class="table-responsive">  
                                <table class="table table-striped table-bordered text-nowrap text-center">  
                                    <thead class="border-top">  
                                        <tr>  
                                            <th>عنوان</th>  
                                            <th>بارکد</th>  
                                            <th>موجودی</th>  
                                            <th>فروشگاه</th>  
                                            <th>انبار</th>  
                                        </tr>  
                                    </thead>  
                                    <tbody>  
                                        <tr v-for="variety in product.varieties">  
                                            <td>{{ variety.title }}</td>  
                                            <td>{{ variety.barcode }}</td>  
                                            <td>{{ variety.store_balance }}</td>  
                                            <td></td>  
                                            <td></td>  
                                        </tr>  
                                    </tbody>  
                                    <tfoot>  
                                        <tr>  
                                            <td colspan="2">مجموع کل موجودی</td>  
                                            <td>  
                                                {{ product.varieties.reduce((total, variety) => total + variety.store_balance, 0) }}  
                                            </td>  
                                            <td>*</td>  
                                            <td>*</td>  
                                        </tr>  
                                    </tfoot>  
                                </table>  
                            </div>  
                        </div>  
                    </div>  
                    <div class="container full-height d-flex justify-content-center align-items-center">  
                        <div class="row col-8 justify-content-between"> 
                            <div>  
                                <h6 class="font-weight-bold">ثبت کننده:</h6>  
                            </div>  
                            <div>  
                                <h6 class="font-weight-bold">تاریخ:</h6>  
                            </div>  
                        </div>  
                    </div>  
                    <div style="width: 100%;">  
                        <hr class="w-100 mx-auto">   
                    </div>  
                </div>
                <div v-if="reports && !reports.length" class="alert alert-primary">  
                    اطلاعاتی موجود نیست
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import { BTable, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
    import configProvider from "@@/core/configProvider";
    import Treeselect from "@riophae/vue-treeselect";
    import "@riophae/vue-treeselect/dist/vue-treeselect.css";
    import reportMixin from "@@/core/mixins/reportMixin";
    import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

    export default {
        name: "varietyBalanceReport",
        components: {
        BTable,
        BFormGroup,
        Treeselect,
        BFormInput,
        ProductSearch,
        BButton,
        BTd,
        },
        configProvider,
        data() {
            return {
                disabled: true,
                page: 1,
                reports: null,
                categories: [],
                stores: [],
                category_id: null,
                selectedStore: null,
                sortBy: null,
                sortDesc: null,
                disabledRest: true,
            };
        },
        mixins: [reportMixin],

        created() {
            this.loadCategoriesData();
            this.loadStores();
        },
        computed: {
            realOptions() {
                let temp = this.$root.addLabel(this.categories);
                temp.unshift({
                    label: "ندارد",
                    children: [],
                    id: 0,
                });

                return temp;
            },
        },
        methods: {
            resetFilter() {
                this.disabledRest = true;
                this.loadData();
            },
            doFilter() {
                this.loadData();
            },
            changePage(page = 1) {
                this.previousPage = this.page;
                this.page = page;
                this.loadData();
            },
            selectVariety(data) {
                this.Variety_id = data;
            },
            selectProduct(data) {
                this.Product_id = data;
            },
            async loadCategoriesData() {
                try {
                const response = await this.$axios.get("admin/categories",{params: {all: 1},});
                this.categories = response.data.data.categories;
                } catch (e) {
                    this.$root.notify(e);
                } finally {
                    this.disabled = false;
                }
            },
            async loadStores(){
                try {
                    const response = await this.$axios.get("admin/stores");
                    this.stores = response.data.data.stores;
                } catch (e) {
                    this.$root.notify(e);
                } 
            },
            async loadData() {
                this.disabledRest = false;
                try {
                this.disabled = true;
                const response = await this.$axios.get(
                    "admin/reports/all-varieties-balance",
                    {
                    params: {
                        category_id: this.category_id == 0 ? null : this.category_id,
                        store_id: this.selectedStore ? this.selectedStore : '',
                    },
                    }
                );
                this.reports = response.data.data.reports;
                } catch (e) {
                    this.$root.notify(e);
                } finally {
                    this.disabled = false;
                }
            },
            showVarieties(productId) {
                this.$root.$emit("bv::show::modal", "show-varieties-modal");
                this.showVarietiesProductId = productId;
            },
        },
    };
</script>
<style>
    hr{
        border-top: 2px solid black;
    }
    .print-only {
        display: none;
    }
    @media print {
        #page-number {  
            position: fixed;  
            bottom: 0;  
            left: 0;  
            right: 0;  
        }  
        hr {  
            border-top: 2px solid black;
            height: 1px;
            background-color: black;
            width: 100%;
        }  
        .not-in-print {
        display: none !important;
        }

        .app-content .side-app {
        padding: 0 !important;
        }

        .print-only {
        display: block !important;
        }

        body * {
        visibility: hidden;
        }
        #print,
        #print * {
        visibility: visible;
        font-size: 1.25rem;
        }
        #print {
        padding: 0 !important;
        }
        #main-table th:last-child,
        #main-table td:last-child {
        display: none;
        }

        #print .not-in-print {
        display: none;
        }
    }
</style>